import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import WebGalleryUpsellBannerFWGOnlyContent from './components/WebGalleryUpsellBannerFWGOnlyContent';
import WebGalleryUpsellBannerPFContent from './components/WebGalleryUpsellBannerPFContent';
import {
  shouldDisplayFWGOnlyUpsellBanner,
  shouldDisplayPFContentUpsellBanner,
} from './helpers';
import { gtm } from '../../../../util/analytics';

const propTypes = {
  className: PropTypes.string,
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onDismiss: PropTypes.func.isRequired,
};

const WebGalleryStickyUpsellBanner = ({
  albumFolder,
  className,
  onDismiss,
}) => {
  const classes = classNames({
    'web-gallery-upsell-banner': true,
    'web-gallery-pro-plus-upsell-banner': true,
    [className]: !!className,
  });

  const label = (() => {
    if (shouldDisplayPFContentUpsellBanner(albumFolder)) {
      return 'PF Onboarding Banner';
    }

    if (shouldDisplayFWGOnlyUpsellBanner(albumFolder)) {
      return 'FWG Only Banner';
    }

    return 'Unknown';
  })();

  useEffect(() => {
    gtm.trackEvent({
      type: 'FWG Upsell Banner',
      action: 'Shown',
      label,
    });
  }, []);

  return (
    <div className={classes}>
      <div className="web-gallery-upsell-content">
        {shouldDisplayFWGOnlyUpsellBanner(albumFolder) && (
          <WebGalleryUpsellBannerFWGOnlyContent />
        )}
        {shouldDisplayPFContentUpsellBanner(albumFolder) && (
          <WebGalleryUpsellBannerPFContent albumFolder={albumFolder} />
        )}
      </div>
      <button
        className="web-gallery-upsell-dismiss-wrap"
        onClick={() => {
          gtm.trackEvent({
            type: 'FWG Upsell Banner',
            action: 'Dismissed',
            label: 'Dismiss Button',
          });
          onDismiss();
        }}
      >
        <b>Dismiss</b> <span className="btn-dismiss" />
      </button>
    </div>
  );
};

WebGalleryStickyUpsellBanner.propTypes = propTypes;

export default WebGalleryStickyUpsellBanner;
